import { Client } from './client';
import {
  CreateEquipmentGroupAssignmentRequest,
  EquipmentGroupAssignmentListResponse,
  EquipmentGroupAssignmentResponse,
} from '@/types/equipmentGroupTypes';
import { FusaReply } from '@/types/replyTypes';

export class EquipmentGroupAssignmentController {
  client: Client;

  constructor(client?: Client) {
    this.client = client || new Client();
  }

  readByProcedureInstanceId(procedureInstanceId: string): Promise<EquipmentGroupAssignmentListResponse> {
    return this.client.read(`/api/equipment-group-assignments/procedure-instance/${procedureInstanceId}`);
  }

  create(body: CreateEquipmentGroupAssignmentRequest): Promise<EquipmentGroupAssignmentResponse> {
    return this.client.create('/api/equipment-group-assignments', body);
  }

  delete(id: string): Promise<FusaReply> {
    return this.client.delete(`/api/equipment-group-assignments/${id}`);
  }
}
